import * as React from 'react';
import { ArticleHeading4, Label } from '@cian/ui-kit';

import { SALES_TYPE_ICONS } from '../../../../constants/salesTypeIcons';
import { ESalesType } from '../../../../types/offersData';

import * as styles from './AdditionalLink.css';
import { IconActionChevronRightSmall16 } from '@cian/ui-kit-design-tokens/icons';

interface ISalesLinkProps {
  type?: ESalesType;
  onClick?(type: ESalesType): void;
  url?: string;
  title: string;
  label?: string;
}

export function AdditionalLink({ onClick, type, url, title, label }: ISalesLinkProps) {
  const icon = type && SALES_TYPE_ICONS.get(type);

  const handleClick = React.useCallback(() => {
    if (!onClick || !type) {
      return;
    }

    onClick(type);
  }, [onClick, type]);

  return (
    <a
      className={styles['link']}
      href={url}
      onClick={handleClick}
      data-testid="AdditionalLink"
      target="_blank"
      rel="noreferrer"
    >
      {icon && <div className={styles['icon--additional']}>{icon}</div>}
      <span className={styles['text']}>
        <ArticleHeading4 as="h4" color="current_color">
          {title}
        </ArticleHeading4>
        {label && (
          <Label color="accent-positive-primary" background="accent-positive-secondary">
            {label}
          </Label>
        )}
        <div className={styles['icon']}>
          <IconActionChevronRightSmall16 />
        </div>
      </span>
    </a>
  );
}
